import { Category, GroupWithCount } from '@/objects/generated';

export class CategoryWithBibAssignFields {
    public BackingValue: Category;

    public NumContestants: number = 0;

    public ForceBibFrom: number | null = null;

    public FromTo: { First: Date | null; Last: Date | null } = { First: null, Last: null };

    /**
     * Helper property that contains the columns that have errors.
     */
    public ErrorColumns: Set<string> = new Set();

    /**
     * Helper property that contains the columns that have warnings.
     */
    public WarningColumns: Set<string> = new Set();

    public get Sort() {
        return this.BackingValue.Sort;
    }
    public set Sort(value) {
        this.BackingValue.Sort = value;
    }

    public get EntityState() {
        return this.BackingValue.EntityState;
    }

    public constructor(category: Category, numContestants: number) {
        this.BackingValue = category;
        this.NumContestants = numContestants;
    }
}

export class GroupWithBibAssignFields {
    public BackingValue: GroupWithCount;

    public NumContestants: number = 0;

    public ForceBibFrom: number | null = null;

    public FromTo: { First: Date | null; Last: Date | null } = { First: null, Last: null };

    /**
     * Helper property that contains the columns that have errors.
     */
    public ErrorColumns: Set<string> = new Set();

    /**
     * Helper property that contains the columns that have warnings.
     */
    public WarningColumns: Set<string> = new Set();

    public get Sort() {
        return this.BackingValue.Sort;
    }
    public set Sort(value) {
        this.BackingValue.Sort = value;
    }

    public get EntityState() {
        return this.BackingValue.EntityState;
    }

    constructor(group: GroupWithCount, numContestants: number) {
        this.BackingValue = group;
        this.NumContestants = numContestants;
    }
}

export type BibAssignBaseTableRow = CategoryWithBibAssignFields | GroupWithBibAssignFields;
